import { render } from "./AddApprovisionnementPage.vue?vue&type=template&id=6c3d87a3&ts=true"
import script from "./AddApprovisionnementPage.vue?vue&type=script&lang=ts"
export * from "./AddApprovisionnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__